import React, { Component } from 'react'
import {localization} from '../../Frames/localization'
import Paper from '@material-ui/core/Paper';
import Label from '../../Elements/Label/labels'
import {ColorLinearProgress, AppliedSettings} from '../../../src/App'
import TableselectSkuSet from '../../Elements/Table/TableselectSkuSet'
import TableselectExtSku from '../../Elements/Table/TableselectExtSku'

import { ThemeProvider } from "@material-ui/styles";
import {ThemeClickElements} from '../../App'

import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import {themeColorText} from '../../../src/App'

import {convert} from '../../Frames/convert'

//Table
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
//DialogWindow
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
//Warning
import clsx from 'clsx';
import Button from "../../Elements/Button/buttons";
import CloseIcon from '@material-ui/icons/Close';
import { amber, green } from '@material-ui/core/colors';
import SnackbarContent from '@material-ui/core/SnackbarContent';
//Message
import MessageWindow from '../../Elements/Snackbar/MessageWindow'
import {messageWindow} from '../../Elements/Snackbar/MessageWindow'



const requestOptionsExit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify("")
}
class CashbackBox extends Component
{
    render()
    { 
        const{data} = this.props.res;
        return(
            <Paper className="CashbackBox">
                
                <Label textLabel={localization.GetTranslate('Cashback.Cashback')} className="CashbackLabel"></Label>
                {data.Cash_Info != "" &&
                <Tooltip title={data.Cash_Info} >
                      <HelpOutlineIcon style={{color: "grey", fontSize: 20, position: "absolute",marginTop: -5, cursor: "pointer"}}></HelpOutlineIcon>
                </Tooltip>
                }
                <Label style={{color: themeColorText.color}} textLabel={data.CashBonus} className="CashbackValueLabel"></Label>
            </Paper>
        );
    }
}
/*class SelectCaskBack_ExtSku extends Component //Товары
{
    constructor(props)
    {
        super(props)
        this.state = {
            resId: Array,
            isLoadedId: false,

            asyncDisabled: false,
            progress: false,

            prod_id: "", 
            prod_idLoad: false, 
        }
        
    }
    componentDidMount() {
        this.setState({asyncDisabled: true, progress: true})
        fetch(`/api/getCashback?id=`+this.props.id, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
                this.setState({
                    resId: response,
                    isLoadedId: true,
                    asyncDisabled: false, 
                    progress: false,          
                });
        })
        fetch(`/api/select_choises_product`, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            this.setState({prod_id: response.data,
                prod_idLoad: true,
                asyncDisabled: false, 
                progress: false,  });
        })
        this.forceUpdate();
      }
      
    render(){
        const {progress} = this.state;
        const {data} = this.state.resId;
        var name = this.props.name;
        var beginDate = convert.ToDateTimeStr(this.props.beginDate);
        var endDate = convert.ToDateTimeStr(this.props.endDate);
        var position = this.props.position;

        var tr ={
            Rule: localization.GetTranslate('Cashback.Rule'),
            to: localization.GetTranslate('Cashback.to'),
            validwith: localization.GetTranslate('Cashback.valid with'),
            Select: localization.GetTranslate('Cashback.Select'),
            position: localization.GetTranslate('Cashback.position')
        }
        var FullRule = tr.Rule + " " + name + " " + tr.validwith + " " + beginDate + " " + tr.to + " " + endDate + " "
        var SelectPosition = "(" + tr.Select + " " + position + " " + tr.position + ")"
        return(
            <div> 
            <Paper className="SelectCashBackBox">
                <Label style={{color: themeColorText.color}} textLabel={FullRule} className="SelectCashBackLabel"></Label>
                <Label textLabel={SelectPosition} className="SelectCashValueLabel"></Label>
                {this.state.isLoadedId && this.state.prod_idLoad &&
                <TableselectExtSku
                id={this.props.id}
                position={position}   
                prod_id={this.state.prod_id}
                data={data}></TableselectExtSku>
                }
                {progress &&
                <div>
                    <br></br>
                    <ColorLinearProgress />  
                </div> 
                }
            </Paper>
            </div>
        );
    }
}
class SelectCaskBack_SkuSet extends Component // Набор товаров
{
    constructor(props)
    {
        super(props)
        this.state = {
            resId: Array,
            isLoadedId: false,

            asyncDisabled: false,
            progress: false,

            prod_id: "", 
            prod_idLoad: false,
        }
    }
    componentDidMount() {
        this.setState({asyncDisabled: true, progress: true})
        fetch(`/api/getCashback?id=`+this.props.id, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
                this.setState({
                    resId: response,
                    isLoadedId: true,
                    asyncDisabled: false, 
                    progress: false,        
                });
        })
        fetch(`/api/select_choises_product`, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            this.setState({
                prod_id: response.data,
                prod_idLoad: true,
                asyncDisabled: false, 
                progress: false,  
            });
        })
        this.forceUpdate();
      }
      
    render(){
        const {progress} = this.state;
        const {data} = this.state.resId;
        var name = this.props.name;
        var beginDate = convert.ToDateTimeStr(this.props.beginDate);
        var endDate = convert.ToDateTimeStr(this.props.endDate);
        var position = this.props.position;
        
        var tr ={
            Rule: localization.GetTranslate('Cashback.Rule'),
            to: localization.GetTranslate('Cashback.to'),
            validwith: localization.GetTranslate('Cashback.valid with'),
            Select: localization.GetTranslate('Cashback.Select'),
            position: localization.GetTranslate('Cashback.position')
        }
        var FullRule = tr.Rule + " " + name + " " + tr.validwith + " " + beginDate + " " + tr.to + " " + endDate + " "
        var SelectPosition = "(" + tr.Select + " " + position + " " + tr.position + ")"
        return(
            <div>
            <Paper className="SelectCashBackBox">
                <Label style={{color: themeColorText.color}} textLabel={FullRule} className="SelectCashBackLabel"></Label>
                <Label textLabel={SelectPosition} className="SelectCashValueLabel"></Label>
                {this.state.isLoadedId && this.state.prod_idLoad &&
                <TableselectSkuSet 
                id={this.props.id}
                position={position} 
                prod_id={this.state.prod_id}
                data={data}></TableselectSkuSet>
                }
                {progress &&
                    <div>
                        <br></br>
                        <ColorLinearProgress />  
                    </div>  
                }  
            </Paper>
            </div>
        );
    }
}*/

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
  
  const useStyles1 = makeStyles(theme => ({
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: theme.palette.primary.main,
    },
    warning: {
      backgroundColor: amber[700],
    },
    icon: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(1),
    },
  }));
function MySnackbarContentWrapper(props) {
    const classes = useStyles1();
    const { className, message, messageValue, onClose, variant, ...other } = props;
  
    return (
      <SnackbarContent
        className={clsx(classes[variant], className)}
        aria-describedby="client-snackbar"
        message={
          <div style={{textAlign:'center'}}>
          <span id="client-snackbar" className="messageWarnText" style={{fontWeight: 'bold'}} >
            {message}  <div style={{fontSize:17, fontWeight: 'bold', marginLeft:5,marginRight:5,marginTop:-2}}>{messageValue}</div>
          </span>
          </div>
        }
        {...other}
      />
    );
  }

  function DataCurrent(props)
    {
        var tr ={
            Rule: localization.GetTranslate('Cashback.Rule'),
            to: localization.GetTranslate('Cashback.to'),
            with: localization.GetTranslate('Cashback.with'),
            Select: localization.GetTranslate('Cashback.Select'),
            position: localization.GetTranslate('Cashback.position')
        }
     var rows = 
        props.BonAchCashR.map(item => (
          createDataCurrent(
            item.id,
            props.selectvalue(item.comment),
            tr.Rule + " " + item.name, 
            "(" + convert.ToDateTimeStr(item.beginDate) + " - " +convert.ToDateTimeStr(item.endDate) + ")",
            Math.floor((item.endDate - Date.now())/ (1000 * 3600 * 24)),
            item.comment,
            item.beginDate,
            item.endDate,
            item.disable
            )
        ))      
      return rows;
    }
  function createDataCurrent(id, selected, nameRules, DateRange, LeftDays, comment, beginDate, endDate, disable) {
    return {id, selected, nameRules, DateRange, LeftDays, comment, beginDate, endDate, disable};
  }
  
  const useStylesCurrent = makeStyles({
    root: {
      width: '100%',
    },
    container: {
      minHeight: 500,
      maxHeight: 500,
    },
  });
  
function TableCurrentRules(props) {
    const rowsCurrent = DataCurrent(props)
    const classes = useStylesCurrent();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(props.AppliedSettings.cashback_products_rows_num);

    const [order] = React.useState('asc');
    const [orderBy] = React.useState('LeftDays');
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
    const handleChangeRowsPerPage = event => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };
    var tr = {
      quantity: localization.GetTranslate('Statistics.Number'),
      of: localization.GetTranslate('Statistics.of')
    }
    return (
        <div>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" className="tableCurrentRules">
            <TableBody>
              {stableSort(rowsCurrent, getSorting(order, orderBy))
               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
                 if(row.beginDate <= Date.now() && row.endDate >= Date.now())
                 {
                  return (
                    <TableRowClass AppliedSettings={props.AppliedSettings} UpdateCashBackInfo={props.UpdateCashBackInfo} type={props.type} ShowMessage={props.ShowMessage} variant={props.variant} row={row}></TableRowClass>
                  );
                 }
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rowsCurrent.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={tr.quantity}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${tr.of} ${count}`}
          classes={{
            root: "rootPagination",
            caption: "rootPagination",
            selectIcon: "rootPagination",
            select: "rootPagination",
            actions: "rootPagination",
          }}
        />
        </div>
    );
  }
////////////Expected

  function DataExpected(props)
    {
      var tr ={
        Rule: localization.GetTranslate('Cashback.Rule'),
        to: localization.GetTranslate('Cashback.to'),
        with: localization.GetTranslate('Cashback.with'),
        Select: localization.GetTranslate('Cashback.Select'),
        position: localization.GetTranslate('Cashback.position')
    }
     var rows = 
        props.BonAchCashR.map(item => (
          createDataExpected(
            item.id,
            props.selectvalue(item.comment),
            tr.Rule + " " + item.name, 
            "(" + convert.ToDateTimeStr(item.beginDate) + " - " +convert.ToDateTimeStr(item.endDate) + ")",
            Math.floor((item.endDate - Date.now())/ (1000 * 3600 * 24)),
            item.comment,
            item.beginDate,
            item.endDate,
            item.disable
            )
        ))
    
      return rows;
    }
  function createDataExpected(id, selected, nameRules, DateRange, LeftDays, comment, beginDate, endDate, disable) {
    return {id, selected, nameRules, DateRange, LeftDays, comment, beginDate, endDate, disable};
  }
  
  const useStylesExpected = makeStyles({
    root: {
      width: '100%',
    },
    container: {
      minHeight: 500,
      maxHeight: 500,
    },
  });
function TableExpectedRules(props) {
    const rowsExpected = DataExpected(props)
    const classes = useStylesExpected();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(props.AppliedSettings.cashback_products_rows_num);

    const [order] = React.useState('asc');
    const [orderBy] = React.useState('LeftDays');
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = event => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };
    var tr = {
      quantity: localization.GetTranslate('Statistics.Number'),
      of: localization.GetTranslate('Statistics.of')
    }
    return (
      <div>
        <TableContainer className={classes.container}>
          <Table className="tableCurrentRules" stickyHeader aria-label="sticky table">
            <TableBody>
              {stableSort(rowsExpected, getSorting(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
                if(row.beginDate > Date.now())
                 {
                  return (
                    <TableRowClass AppliedSettings={props.AppliedSettings} UpdateCashBackInfo={props.UpdateCashBackInfo} type={props.type} ShowMessage={props.ShowMessage} variant={props.variant} row={row}></TableRowClass>
                  );
                 }
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rowsExpected.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={tr.quantity}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${tr.of} ${count}`}
          classes={{
            root: "rootPagination",
            caption: "rootPagination",
            selectIcon: "rootPagination",
            select: "rootPagination",
            actions: "rootPagination",
          }}
        />
        </div>
    );
  }
 class TableRowClass extends Component {
   constructor(props)
   {
     super(props)
     this.state = {
        open: false,
        row: this.props.row,
        key: undefined,

        resId: Array,
        isLoadedId: false,

        asyncDisabled: false,
        progress: false,

        prod_id: "", 
        prod_idLoad: false,

        id_product: [],
        id_rule: []
     }
     this.handleOpen = this.handleOpen.bind(this)
     this.handleClose = this.handleClose.bind(this)
     this.onSubmit = this.onSubmit.bind(this)
   }
   componentDidMount()
   {
    this.setState({asyncDisabled: true, progress: true})
    fetch(`/api/getCashback?id=`+this.props.row.id, requestOptionsExit)
    .then((response) => response.json())
    .then((response) => {
            this.setState({
                resId: response,
                isLoadedId: true,
                asyncDisabled: false, 
                progress: false,        
            });
    })
    fetch(`/api/select_choises_product?id=`+this.props.row.id, requestOptionsExit)
    .then((response) => response.json())
    .then((response) => {
        this.setState({
            prod_id: response.data,
            prod_idLoad: true,
            asyncDisabled: false, 
            progress: false,  
        });
    })
    this.forceUpdate();
   }
   onSubmit(event, id){

        this.setState({asyncDisabled: true, progress: true})
        var id_product = [];
        var id_rule = [];

        var form = document.getElementById('cashForm');
        var checkboxes = form.getElementsByTagName("input")
        for(var j=0; j<checkboxes.length; j++)
        {
            if (checkboxes[j].type == 'checkbox')
            {
                if (checkboxes[j].checked == true)
                {   
                    id_rule.push(id)
                    id_product.push(checkboxes[j].id)
                }
            }
        }

    var data = {
        id_Rule: id_rule,
        id_Product: id_product
    }
    const requestOptionsExit = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }
    fetch(`/alterCashback`, requestOptionsExit)
    .then((response) => {
        if(response.status == 500)
        {
            messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
            this.setState({asyncDisabled: false, progress: false,key: Math.random()})
        }
         return response.json()})
    .then((response) => {
        if(response.error == null)
        { 
            this.setState({asyncDisabled: false, progress: false})
            this.props.ShowMessage("success", localization.GetTranslate(response.data));
            this.componentDidMount()
            this.handleClose()
            this.forceUpdate()
        }else
        {
            messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
            this.setState({asyncDisabled: false, progress: false,key: Math.random()})
        }
    })
    this.forceUpdate()
    event.preventDefault();
  }
   handleOpen()
   {
     if(this.state.open == false)
     {
      this.setState({open: true})
     }
   }
   handleClose()
   {
       this.setState({open: false, key: Math.random()})
   }
   Contains(value)
  {
    var prod = this.state.prod_id.split(',');
    for(var j=0; j < prod.length; j++)
    {
        if(prod[j] == value.id)
        {
          return true;
        }
    }
    return false;
  }
  show_product_or_sku_set_name(variant,product_name_view,sku_set_name)
  {
    switch(variant)
    {
      case '1': 
      {
          if(sku_set_name === true)
          {
            
            return this.handleOpen();
          }
          else
          {
            return;
          }
      }
      case '2':
      {
          if(product_name_view === true)
          {
            
            return this.handleOpen();
          }
          else
          {
            return;
          }
      }
      default: return this.handleOpen();
    }
  } 
   render()
   {
     const {progress} = this.state;
     const {data} = this.state.resId;
     const {row} = this.state;
     var CountSelect = 0;
     if(data != undefined && this.state.prod_id != undefined)
     {
          this.props.variant(row.comment) == 1 &&
          data.SkuSets.map(item => (
            this.Contains(item) === true ? CountSelect++:CountSelect
          ))
          this.props.variant(row.comment) == 2 &&
          data.ExtCodes.map(item => (
            this.Contains(item) === true ? CountSelect++:CountSelect
          ))
     }
     var tr ={
      Select: localization.GetTranslate('Cashback.Select'),
      position: localization.GetTranslate('Cashback.position'),
      with: localization.GetTranslate('Cashback.with')
    }
     var SelectPosition = "(" + tr.Select + " " + row.selected + " " + tr.position + ")"
     var Selected = "("+CountSelect+" "+ tr.with + " " + row.selected + ")"
     return(
      <TableRow key={this.state.key} onClick={() => this.show_product_or_sku_set_name(this.props.variant(row.comment),AppliedSettings.cashback_product_name_view,AppliedSettings.cashback_sku_set_name_view)} hover role="checkbox" tabIndex={-1} className="tableRowRules">
        {AppliedSettings.cashback_check_item_view &&
          row.selected == CountSelect &&
          <TableCell style={{color: themeColorText.color, fontWeight: 'bold',minWidth: 100}} align="center">{Selected}</TableCell>
          }
          {AppliedSettings.cashback_check_item_view &&
          row.selected != CountSelect &&
            <TableCell className="SelectedItem" align="center">{Selected}</TableCell>
          }
          {this.props.type == "current" &&
          <TableCell align="center">
              <div style={{color: themeColorText.color}} className="nameRulesCurrent">{row.nameRules}</div>
              <div className="nameRulesDate">{row.DateRange}</div>
          </TableCell>
          }
          {AppliedSettings.cashback_end_notification_text &&
          this.props.type == "current" &&
          <TableCell align="right" className="LeftDaysCurrent">
            {row.LeftDays <= AppliedSettings.cashback_end_days_num &&
              <MySnackbarContentWrapper
                    variant="warning"
                    style={{maxWidth: 180, minWidth: 10, margin: 'auto', padding: "0px 15px", boxShadow: 'none'}}
                    message={localization.GetTranslate('Cashback.Days left')+": "}
                    messageValue={row.LeftDays}
                />
            }
          </TableCell>
          }
          {this.props.type == "expected" &&
          <TableCell align="center">
              <div className="nameRulesExpected">{row.nameRules}</div>
              <div className="nameRulesDate">{row.DateRange}</div>
          </TableCell>
          /*<TableCell className="SelectedItem" align="center">{row.selected}</TableCell>
                      <TableCell align="center">
                           <div className="nameRulesExpected">{row.nameRules}</div>
                           <div className="nameRulesDate">{row.DateRange}</div>
                        </TableCell>*/
          }
        <Dialog
            open={this.state.open}
            scroll={'paper'}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"                      
          >
            <DialogTitle id="scroll-dialog-title" align='center' style={{padding: "0px 24px"}} className="DialogTitle">
                    <CloseIcon style={{position: "absolute", top: 10, right: 15}} onClick={this.handleClose} className="DialogClose"></CloseIcon>
                    <Label style={{color: themeColorText.color}} textLabel={row.nameRules} className="SelectCashBackLabel"></Label>
                    <br></br>
                    <Label style={{color: themeColorText.color}} textLabel={row.DateRange} className="SelectCashBackLabelDate"></Label>
                    <Label textLabel={SelectPosition} className="SelectCashValueLabel"></Label>
            </DialogTitle>
            <DialogContent dividers={'paper'} style={{padding: "5px 24px"}} className="DialogContent">
                <DialogContentText
                id="scroll-dialog-description"                            
                tabIndex={-1}
                >
                  <div id="cashForm">
                    {this.state.isLoadedId && this.state.prod_idLoad &&
                      this.props.variant(row.comment) == 1 &&
                        <TableselectSkuSet
                        AppliedSettings={this.props.AppliedSettings}
                        id={row.id}
                        position={row.selected}   
                        prod_id={this.state.prod_id}
                        data={data}
                        disable={row.disable}
                        ></TableselectSkuSet>
                      }
                      {this.state.isLoadedId && this.state.prod_idLoad &&
                      this.props.variant(row.comment) == 2 &&
                        <TableselectExtSku
                        id={row.id}
                        position={row.selected} 
                        prod_id={this.state.prod_id}
                        data={data}
                        disable={row.disable}
                        ></TableselectExtSku>
                      }                       
                    {progress &&
                    <div>
                        <br></br>
                        <ColorLinearProgress />  
                    </div> 
                    }
                </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{display:"block"}} className="DialogActions">
            <div className="BoxSaveButton">
              <ThemeProvider theme={ThemeClickElements}>
              <Button
                variant="contained"
                type="submit"
                value="submit"
                color="primary"
                textLabel={localization.GetTranslate('buttons.Save')}
                className="SaveButtonCashback"
                disabled={this.state.asyncDisabled || row.disable}
                onClick={event => this.onSubmit(event, row.id)}
              >
              </Button>
              </ThemeProvider>
            </div> 
            </DialogActions>
          </Dialog> 
          <MessageWindow key={this.state.key} ></MessageWindow> 
      </TableRow>
       
     );
   }
 }



/*
class ExtSku extends Component //Товары
{
    constructor(props)
    {
        super(props)
        this.state = {
            resId: Array,
            isLoadedId: false,

            asyncDisabled: false,
            progress: false,

            prod_id: "", 
            prod_idLoad: false, 
        }
        
    }
    componentDidMount() {
        this.setState({asyncDisabled: true, progress: true})
        fetch(`/api/getCashback?id=`+this.props.id, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
                this.setState({
                    resId: response,
                    isLoadedId: true,
                    asyncDisabled: false, 
                    progress: false,          
                });
        })
        fetch(`/api/select_choises_product`, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            this.setState({prod_id: response.data,
                prod_idLoad: true,
                asyncDisabled: false, 
                progress: false,  });
        })
        this.forceUpdate();
      }
      
    render(){
        const {progress} = this.state;
        const {data} = this.state.resId;
        var name = this.props.name;
        var beginDate = convert.ToDateTimeStr(this.props.beginDate);
        var endDate = convert.ToDateTimeStr(this.props.endDate);
        var position = this.props.position;

        var tr ={
            Rule: localization.GetTranslate('Cashback.Rule'),
            to: localization.GetTranslate('Cashback.to'),
            validwith: localization.GetTranslate('Cashback.valid with'),
            Select: localization.GetTranslate('Cashback.Select'),
            position: localization.GetTranslate('Cashback.position')
        }
        var FullRule = tr.Rule + " " + name + " " + tr.validwith + " " + beginDate + " " + tr.to + " " + endDate + " "
        var SelectPosition = "(" + tr.Select + " " + position + " " + tr.position + ")"
        return(
            <div> 
            <Paper className="SelectCashBackBox">
                <Label style={{color: themeColorText.color}} textLabel={FullRule} className="SelectCashBackLabel"></Label>
                <Label textLabel={SelectPosition} className="SelectCashValueLabel"></Label>
                {this.state.isLoadedId && this.state.prod_idLoad &&
                <TableselectExtSku
                id={this.props.id}
                position={position}   
                prod_id={this.state.prod_id}
                data={data}></TableselectExtSku>
                }
                {progress &&
                <div>
                    <br></br>
                    <ColorLinearProgress />  
                </div> 
                }
            </Paper>
            </div>
        );
    }
}
class SkuSet extends Component // Набор товаров
{
    constructor(props)
    {
        super(props)
        this.state = {
            resId: Array,
            isLoadedId: false,

            asyncDisabled: false,
            progress: false,

            prod_id: "", 
            prod_idLoad: false,
        }
    }
    componentDidMount() {
        this.setState({asyncDisabled: true, progress: true})
        fetch(`/api/getCashback?id=`+this.props.id, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
                this.setState({
                    resId: response,
                    isLoadedId: true,
                    asyncDisabled: false, 
                    progress: false,        
                });
        })
        fetch(`/api/select_choises_product`, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            this.setState({
                prod_id: response.data,
                prod_idLoad: true,
                asyncDisabled: false, 
                progress: false,  
            });
        })
        this.forceUpdate();
      }
      
    render(){
        const {progress} = this.state;
        const {data} = this.state.resId;
        var name = this.props.name;
        var beginDate = convert.ToDateTimeStr(this.props.beginDate);
        var endDate = convert.ToDateTimeStr(this.props.endDate);
        var position = this.props.position;
        
        var tr ={
            Rule: localization.GetTranslate('Cashback.Rule'),
            to: localization.GetTranslate('Cashback.to'),
            validwith: localization.GetTranslate('Cashback.valid with'),
            Select: localization.GetTranslate('Cashback.Select'),
            position: localization.GetTranslate('Cashback.position')
        }
        var FullRule = tr.Rule + " " + name + " " + tr.validwith + " " + beginDate + " " + tr.to + " " + endDate + " "
        var SelectPosition = "(" + tr.Select + " " + position + " " + tr.position + ")"
        return(
            <div>
            <Paper className="SelectCashBackBox">
                <Label style={{color: themeColorText.color}} textLabel={FullRule} className="SelectCashBackLabel"></Label>
                <Label textLabel={SelectPosition} className="SelectCashValueLabel"></Label>
                {this.state.isLoadedId && this.state.prod_idLoad &&
                <TableselectSkuSet 
                id={this.props.id}
                position={position} 
                prod_id={this.state.prod_id}
                data={data}></TableselectSkuSet>
                }
                {progress &&
                    <div>
                        <br></br>
                        <ColorLinearProgress />  
                    </div>  
                }  
            </Paper>
            </div>
        );
    }
}*/
export {CashbackBox, TableCurrentRules, TableExpectedRules};